module.exports = __webpack_public_path__ + "static/media/blueTickCircle.3396b78d.svg";